// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__VQS0T","error":"styles_error__ryjw0"};